import { render, staticRenderFns } from "./Utenze.vue?vue&type=template&id=5e5b457d&"
import script from "./Utenze.vue?vue&type=script&lang=ts&"
export * from "./Utenze.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports